import React from 'react';

import { ISpacerProps } from './models';
import styles from './styles.module.scss';

const ScreensDragSpacer: React.FunctionComponent<ISpacerProps> = (props) => {
  const { position, dataTestId = 'screensDragSpacer' } = props;

  return (
    <div
      className={styles.screensSpacer}
      style={{ order: position }}
      data-testid={dataTestId}
    />
  );
};

export default ScreensDragSpacer;
